import { PersonalizedTextVariable } from 'api/landingPageTheme'
import { buildTranslate } from 'locales'

const t = buildTranslate(
  'cms.content.app_home_page.content.edit_block.content.personalized_text'
)

export type Tag = {
  key: PersonalizedTextVariable
  label: string
  supportsPlaceholder: boolean
}

export const mergeTags: Tag[] = [
  {
    key: 'first_name',
    label: t('merge_tags.first_name'),
    supportsPlaceholder: true,
  },
  {
    key: 'last_name',
    label: t('merge_tags.last_name'),
    supportsPlaceholder: true,
  },
  {
    key: 'points_balance',
    label: t('merge_tags.points_balance'),
    supportsPlaceholder: false,
  },
  {
    key: 'points_currency',
    label: t('merge_tags.points_currency'),
    supportsPlaceholder: false,
  },
]
